<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
    <p>
        Sorry! :-( <br/>
        An unmanaged error has occurred.<br/>
        Report the error by writing an email to <i>info@jenia.it</i> 
    </p>
  </mat-card-content>
</mat-card>
